import { render } from "./FooterView.vue?vue&type=template&id=4430dac0"
import script from "./FooterView.vue?vue&type=script&lang=js"
export * from "./FooterView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\luke\\Desktop\\poll_dashboard_new\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__